import { createAsyncThunk } from '@reduxjs/toolkit'
import DataService from "../service";
import { constant } from '../constant'
const { path } = constant;
export const fetchLocationList = createAsyncThunk(
    'location/fetchLocation',
    (arg, { rejectWithValue }) => DataService.get(arg,  path+'/client/location/v1/list', rejectWithValue)
)

export const createUpdateLocation = createAsyncThunk(
    'location/createUpdateLocation',
    (arg, { rejectWithValue }) => DataService.post(arg, path+'client/location/v1', rejectWithValue)
)

export const deleteLocation = createAsyncThunk(
    'locations/deleteLocation',
    (arg, { rejectWithValue }) => DataService.delete(arg, path+`client/location/v1/delete/${arg?.locationId}`, rejectWithValue)
)

